import apiClient from './api'
const base = 'gestock/auth/email'
export async function emailAuth(action: string, payload: any) {
  try { return (await apiClient.post(`${base}/${action}`, payload)).data }
  catch (error: any) { throw error.response?.data || error }
}
